import CountNumber from '@/Components/CountNumber';
import { Link } from '@inertiajs/react';
import { Button } from 'antd';
import React from 'react'
import { useTranslation } from 'react-i18next';

import map from '@/../../public/sliders/map.jpg'
export default function AboutUs({ aboutus }: any) {
    const { t, i18n } = useTranslation();
    return (
        <div className='m-5  grid grid-cols-2  xs:grid-cols-1'>

            <div className='flex items-start flex-col gap-12 justify-center mx-auto '>
                {
                    aboutus === null?
                        <div
                        // className='flex flex-col items-center gap-4'
                        >
                            <div className='flex items-center  justify-start  dark:text-white my-4 '>
                                <div className='relative group overflow-hidden'>

                                <p className='relative z-10 hover:text-white font-bold lg:text-base text-sm p-4 pt-1 '>

                                    {aboutus?.name[i18n.language]}
                                </p>

                                <div className={`absolute inset-y-0 ${i18n.language === 'ar' ? 'right-0' : 'left-0'}  w-0 bg-yellow-400 rounded-full transition-all duration-300 ease-in-out group-hover:w-full z-0`}></div>

                                </div>

                            </div>

                            <p className='text-2xl xs:text-base dark:text-white text-[#071952] p-5 '> {aboutus?.content[i18n.language]}</p>
                        </div>
                        :
                        <div className='flex items-start  flex-col  dark:text-white my-4 '>
                            <p  className=' text-custom-dark-blue  font-bold lg:text-base text-sm p-4 '> {t('aboutus.name')}</p>
                            <p className='lg:text-base text-sm dark:text-white text-black p-5 leading-10'> {t('aboutus.content')}</p>
                        </div>
                        }

            </div>
            <div className='flex justify-center items-center xs:flex-wrap'>
                <img src={map} className={`object-cover w-[530px] mt-8 ${i18n.language === 'en' && '[transform:rotateY(180deg)]'} `}

                />
                <Button className='p-5 rounded-full text-lg font-semibold m-5 font-sans hover:!bg-custom-dark-blue hover:!text-white hover:!border-white self-end'>
                    <Link href={route('client.aboutus.index', { locale: i18n.language })}>
                        {t('btn.showmore')}
                    </Link>
                </Button>
            </div>
        </div>
    )
}
